// extracted by mini-css-extract-plugin
module.exports = {"TabContainer":"ProjectsPage_TabContainer__w8pHE"};